import React from "react";
import { connect } from "react-redux";

import { listF2 } from "../../actions/listF2Act";

import * as ROUTES from "../../constant/routes"
import { TPlatformType } from "../common/common";


class SideBar extends React.Component {

	componentDidMount() {
		this.getListF2()
	}

	getListF2() {
		this.props.dispatch(listF2(0, 0, 0))
	}

	render() {
		const { platformType } = this.props.appInit;
		const { listF2 } = this.props.listF2;

		return <nav className="page-sidebar" id="sidebar">
					<div id="sidebar-collapse">
						<ul className="side-menu metismenu">
								<li><a href={ROUTES.DASHBOARD}><i className="sidebar-item-icon ti-home"></i><span className="nav-label">Dashboard</span></a></li>
								{platformType === TPlatformType.AGENT && listF2.length > 0 && <li><a href={ROUTES.TRACKING_REPORT}><i className="sidebar-item-icon las la-chalkboard"></i><span className="nav-label">Tracking Report</span></a></li>}
								<li><a href={ROUTES.ORDER_SEARCHING}><i className="sidebar-item-icon ti-car"></i><span className="nav-label">Đặt chuyến</span></a></li>
								<li><a href={ROUTES.MY_TRIPS}><i className="sidebar-item-icon la la-suitcase"></i><span className="nav-label">Chuyến của tôi</span></a></li>
								<li><a href={ROUTES.MY_WALLET}><i className="sidebar-item-icon ti-wallet"></i><span className="nav-label">Ví của tôi</span></a></li>
						</ul>
					</div>
				</nav>
	}
}


function mapState(state) {
	return {
		appInit: state.appInit,
		listF2: state.listF2
	}
}

SideBar = connect(mapState)(SideBar)

export default SideBar


// WEBPACK FOOTER //
// ./src/components/common/sidebar.js